module.exports = __webpack_public_path__ + "img/caru_2kl.1a276abd.jpg";